module.exports = __webpack_public_path__ + "static/media/low-4.bb20525a.png";